import { useEffect, useState } from "react";
import { fetchAdminRewardOrdersAPI } from "./rewardAPI";
import "./Reward.css";

// 관리자 > 기프티콘 교환(2026-10-12). 모든 학원 학생이 포인트로 받아 간 쿠폰. 학원을 누르면 그 학원만 본다.
// 학원 자기 것은 학원 관리 > 포인트 · 기프티콘 의 '교환 내역' 에 있다.

const formatNumber = (value) => (value ?? 0).toLocaleString("ko-KR");
const formatDateTime = (value) =>
  value ? new Date(value).toLocaleString("ko-KR", { month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

const AdminRewardOrderPage = () => {
  const [academyList, setAcademyList] = useState([]);
  const [orderList, setOrderList] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchAdminRewardOrdersAPI(selectedUserId)
      .then((data) => {
        if (!selectedUserId) setAcademyList(data.academy_list);
        setOrderList(data.order_list);
      })
      .catch(() => setMessage("교환 내역을 불러오지 못했어요."));
  }, [selectedUserId]);

  const selectedAcademy = academyList.find((one) => one.user_id === selectedUserId);

  return (
    <div className="reward-page">
      <div className="reward-card">
        <div className="reward-card__title">학원별 교환</div>
        {message && <div className="reward-message">{message}</div>}
        {academyList.length === 0 ? (
          <div className="reward-empty">아직 교환한 학원이 없어요.</div>
        ) : (
          <table className="reward-table">
            <thead>
              <tr>
                <th>학원</th>
                <th style={{ textAlign: "right" }}>받아 간 학생</th>
                <th style={{ textAlign: "right" }}>쿠폰</th>
                <th style={{ textAlign: "right" }}>이번 달</th>
                <th style={{ textAlign: "right" }}>누적</th>
                <th style={{ textAlign: "right" }}>실패</th>
              </tr>
            </thead>
            <tbody>
              {academyList.map((academy) => (
                <tr
                  key={academy.user_id}
                  className="reward-table__row"
                  aria-selected={academy.user_id === selectedUserId}
                  onClick={() => setSelectedUserId(academy.user_id === selectedUserId ? null : academy.user_id)}
                >
                  <td>{academy.academy_name}</td>
                  <td className="reward-table__num">{academy.student_count}명</td>
                  <td className="reward-table__num">{academy.issued_count}장</td>
                  <td className="reward-table__num">{formatNumber(academy.this_month_points)}P</td>
                  <td className="reward-table__num">{formatNumber(academy.issued_points)}P</td>
                  <td className="reward-table__num">{academy.failed_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="reward-card">
        <div className="reward-card__title">
          교환 내역
          <em>{selectedAcademy ? selectedAcademy.academy_name : "전체 학원"}</em>
        </div>
        {orderList && orderList.length === 0 && <div className="reward-empty">교환 내역이 없어요.</div>}
        {orderList && orderList.length > 0 && (
          <table className="reward-table">
            <thead>
              <tr>
                <th>시각</th>
                <th>학원</th>
                <th>학생</th>
                <th>상품</th>
                <th>상태</th>
                <th style={{ textAlign: "right" }}>포인트</th>
              </tr>
            </thead>
            <tbody>
              {orderList.map((order) => (
                <tr key={order.id}>
                  <td>{formatDateTime(order.created_at)}</td>
                  <td>{order.academy_name}</td>
                  <td>{order.student_name}</td>
                  <td>
                    {order.product.brand_name} {order.product.goods_name}
                  </td>
                  <td>{order.status_label}</td>
                  <td className="reward-table__num">{formatNumber(order.points_used)}P</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminRewardOrderPage;
